export class ReportCriteriaConst {
    static CRITERIA_NAME = "CriteriaName";
    static CRITERIA_FIELD_LABEL = "CriteriaFieldLabel";
    static CRITERIA_FIELD_TYPE_CONTROL = "CriteriaFieldType";
    static CRITERIA_FIEL_COMPARISON_CONTROL = "CriteriaFieldComparison";
    static CRITERIA_VIEW_COLUMN_CONTROL = "CriteriaViewColumn";
    static CRITERIA_FIELD_VALUE_CONTROL = "CriteriaFieldValue";
    static REPORT_ID_CONTROL = "reportID";
    static MODULE_ID_CONTROL = "moduleId";
    static EXTENTION_CONTROL = "extention";
    static REPORT_CRITERIA_CONTROL = "reportCriteria";
    static REPORT_DATA_INFO_CONTROL = "reportDataInfo";
    static EXPORT_TYPE_CONTROL = "exportType";
    static REPORT_GROUP_CONTROL = "reportGroup";
    static UPLOAD_REPORT_CONTOL = "uploadReport";
    static REPORT_AVAILABLE_IN_PORTAL_CONTROL = "canDownloadInPortal";
    static JOB_ID_CONTOL = "jobId";
    static COMPONENT_TYPE_CONTOL = "componentType";
    static SUBMIT_BTN_LBL = "Generate Report";
    static CRITERIA_TITLE = "Report";
    static SELECT_REPORT_GROUP = "Select report group";
    static SELECT_REPORT_GROUP_FIELD_NAME = "Report group";
    static SELECT_REPORT = "Select report";
    static SELECT_REPORT_FIELD_NAME = "Report name";
    static SELECT_FILE_EXPORT_TYPE = "Select file export type";
    static SELECT_FILE_EXPORT_TYPE_FIELD_NAME = "File export type";
    static UPLOAD_REPORT = "Upload report";
    static AVAILABLE_IN_PORTAL_LABEL_REPORT = "Mark report as available in portal";
    static NO_DATA_FOR_REPORT = "No data for the report.";
    static INVALID_REPORT_GROUP_NAME = "Invalid report group name.";
    static INVALID_REPORT_NAME = "Invalid report name.";
    static MONTH_LBL = "month";
    static DAY_LBL = "day";
    static MONTH_ERROR = "between 1-12";
    static DAY_ERROR = "between 1-31";
    static MONTHS_REGEX = "(?:January|February|March|April|May|June|July|August|September|October|November|December|january|february|march|april|may|june|july|august|september|october|november|december)";
    static MONTHS_REGEX_ERROR = "must be a valide month eg. january";
    // NB: the date format in the shared constants doesn't work when using default dates
    static DATE_CONST = "yyyy-MM-dd";
}
